var _text, _text2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCmmcLevel2Logo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 100",
    width: 200,
    height: 100,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 100,
    y: 45,
    fontFamily: "Arial, sans-serif",
    fontSize: 36,
    fontWeight: "bold",
    fill: "black",
    textAnchor: "middle"
  }, "CMMC")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 100,
    y: 75,
    fontFamily: "Arial, sans-serif",
    fontSize: 24,
    fill: "black",
    textAnchor: "middle"
  }, "Level 2")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCmmcLevel2Logo);
export default __webpack_public_path__ + "static/media/cmmc-level-2-logo.931430c9.svg";
export { ForwardRef as ReactComponent };